<div class="gallery-container">
  <div class="image-wrapper">
    <div class="image-container" (click)="!customError && onImageClick()" role="button" tabindex="0" (keydown.enter)="!customError && onImageClick()"
      [attr.aria-description]="'iaa.aria.clickToEnlarge'| translate">
      
      <!-- Image Display -->
      <img *ngIf="!customError && !isImageError(activeIndex)" 
           [src]="thumbnails[activeIndex].imageUrl" 
           class="contained-image" 
           [alt]="getImageAltText()"
           (load)="onImageLoad(activeIndex)"
           (error)="onImageError(activeIndex, $event)" />
      
      <!-- Custom Error Display -->
      <div *ngIf="customError" class="image-error-container">
        <div class="error-content">
          <i class="pi pi-exclamation-triangle error-icon"></i>
          <div class="error-message">
           <bdi> <h4>{{ customError | translate }}</h4></bdi>
          </div>
        </div>
      </div>

      <!-- Error State Display -->
      <div *ngIf="!customError && isImageError(activeIndex)" class="image-error-container">
        <div class="error-content">
          <i class="pi pi-exclamation-triangle error-icon"></i>
          <div class="error-message">
            <h4 *ngIf="isImageUnsupported(activeIndex)">{{ 'iaa.gallery.unsupportedFormat' | translate }}</h4>
            <h4 *ngIf="!isImageUnsupported(activeIndex)">{{ 'iaa.gallery.imageLoadError' | translate }}</h4>
          </div>
        </div>
      </div>

      <!-- Inside the clickable container, so the icon opens the viewer like the image does. -->
      <i *ngIf="!customError && !isImageError(activeIndex)" class="pi pi-search-plus magnifying-glass"></i>
    </div>
    <div *ngIf="!customError" class="image-pagination">
      <span class="pagination-side">
        <button type="button" class="pi pi-angle-double-left pagination-btn" (click)="firstImage()"
          [disabled]="activeIndex === 0" [attr.aria-disabled]="activeIndex === 0"
          [attr.aria-label]="'iaa.aria.imageFirst' | translate"></button>
        <button type="button" class="pi pi-angle-left pagination-btn" (click)="prevImage()"
          [disabled]="activeIndex === 0"[attr.aria-disabled]="activeIndex === 0"
          [attr.aria-label]="'iaa.aria.imagePrev'| translate"></button></span>
      <span style="color:#8E6F3E!important" aria-live="polite">{{ activeIndex + 1 }} / {{ thumbnails.length }}</span>
      <span class="pagination-side">
        <button type="button" class="pi pi-angle-right pagination-btn" (click)="nextImage()"
          [disabled]="activeIndex === thumbnails.length - 1" [attr.aria-disabled]="activeIndex === thumbnails.length - 1"
          [attr.aria-label]="'iaa.aria.imageNext' | translate"></button>
        <button type="button" class="pi pi-angle-double-right pagination-btn" (click)="lastImage()"
          [disabled]="activeIndex === thumbnails.length - 1" [attr.aria-disabled]="activeIndex === thumbnails.length - 1"
          [attr.aria-label]="'iaa.aria.imageLast'|translate"></button>
      </span>
    </div>
  </div>

  <p-galleria [value]="images" [(visible)]="displayCustom" [(activeIndex)]="activeIndex" [fullScreen]="true"
    [showItemNavigators]="false" [showIndicators]="false" [containerStyle]="{'max-width': '80%'}"
    [showThumbnails]="false" (visibleChange)="resetZoom()">
    <ng-template pTemplate="header">
      <div class="toolbar">
        <p-button [id]="'zoomOut'" icon="pi pi-search-minus icon" class="mr-2" (click)="zoomOut()"
          (keydown.enter)="zoomOut()" [ariaLabel]="'iaa.aria.zoomOut' | translate"></p-button>
        <p-button [id]="'zoomIn'" icon="pi pi-search-plus icon" class="mr-2" (click)="zoomIn()"
          (keydown.enter)="zoomIn()" [ariaLabel]="'iaa.aria.zoomIn' | translate"></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="item" let-item>
      <div class="preview-image-container">
        <button class="nav-btn prev" [attr.aria-label]="'iaa.aria.imagePrev' | translate"
          [disabled]="activeIndex === 0" (click)="prevImage()">
          <span class="pi pi-chevron-left gallery-nav-icon"></span>
        </button>
        <div class="image-inner-container">
          <!-- Image Display in Fullscreen -->
          <img *ngIf="!isImageError(activeIndex)" 
               [src]="item.imageUrl" 
               class="gallery-image" 
               [alt]="getImageAltText()" 
               [title]="item.imageDescription"
               [style.transform]="zoomLevel" 
               (wheel)="onWheel($event)"
               (load)="onImageLoad(activeIndex)"
               (error)="onImageError(activeIndex, $event)" />
          
          <!-- Error State in Fullscreen -->
          <div *ngIf="isImageError(activeIndex)" class="gallery-error-container">
            <div class="error-content">
              <i class="pi pi-exclamation-triangle error-icon"></i>
              <div class="error-message">
                <h4 *ngIf="isImageUnsupported(activeIndex)">{{ 'iaa.gallery.unsupportedFormat' | translate }}</h4>
                <h4 *ngIf="!isImageUnsupported(activeIndex)">{{ 'iaa.gallery.imageLoadError' | translate }}</h4>
                <p>{{ getImageErrorMessage(activeIndex) }}</p>
              </div>
            </div>
          </div>
          
          <div class="caption-container">
            <div *ngFor="let detail of imageDetails">
              <div *ngIf="images[activeIndex]?.[detail['property']]" class="caption">
                <span class="caption-title">{{ detail.label | translateLang | async}}</span>
                {{ images[activeIndex][detail.property] }}
              </div>
            </div>
          </div>
        </div>
        <button class="nav-btn next" [attr.aria-label]="'iaa.aria.imageNext' | translate"
          [disabled]="activeIndex === images.length - 1" (click)="nextImage()">
          <span class="pi pi-chevron-right gallery-nav-icon"></span>
        </button>
      </div>
    </ng-template>
  </p-galleria>
</div>